<div class="accordion" id="propertiesAccordion">
    <ng-container *ngIf="installation">
        <div class="card">
            <div class="card-header" id="generalHeader">
                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                    data-target="#generalCollapse" aria-expanded="true" aria-controls="generalCollapse">Général</button>
            </div>
            <div id="generalCollapse" class="panel-collapse collapse" aria-labelledby="generalHeader"
                data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a></div> -->
                    <p class="col-sm-3 col-6">Nom installation : </p>
                    <p class="col-sm-3 col-6">{{installation.nom_installation}}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Entité propriétaire : </p>
                    <p class="col-sm-3 col-6">{{installation.societe_proprietaire.raison_sociale}}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Propriétaire(s) : </p>
                    <p class="col-sm-3 col-6">
                        <ng-container *ngFor="let proprietaire of installation.societe_proprietaire.proprietaires">
                            {{proprietaire.nom_personne}}&nbsp;
                        </ng-container>
                    </p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Statut : </p>
                    <p class="col-sm-3 col-6">{{installation.statuts.en_cours.nom_statut}}</p>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Projet depuis le : </p>
                    <p class="col-sm-3 col-6">{{installation.statuts.date_projet}}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Installée le : </p>
                    <p class="col-sm-3 col-6">{{installation.statuts.date_installation}}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Mise en service le : </p>
                    <p class="col-sm-3 col-6">{{installation.statuts.date_mise_en_service}}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Arrêtée le : </p>
                    <p class="col-sm-3 col-6"> {{ installation.statuts.date_arret}}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Désinstallée le : </p>
                    <p class="col-sm-3 col-6">{{ installation.statuts.date_desinstallation }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Retour atelier le : </p>
                    <p class="col-sm-3 col-6">&nbsp;
                    </p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="infosHeader">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                    data-target="#infosCollapse" aria-expanded="false" aria-controls="infosCollapse">Infos SAV</button>
            </div>
            <div id="infosCollapse" class="collapse" aria-labelledby="infosHeader" data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a></div> -->
                    <p class="col-6 col-sm-3">Type de consommables : </p>
                    <p class="col-6 col-sm-3">{{ installation.sav.nom_consommables }}</p>
                    <div class="w-100"></div>
                    <p class="col-6 col-sm-3">Gestion de parc : </p>

                    <ng-container *ngIf="installation.sav.synchro_enabled">
                        <p class="col-6 col-sm-3">Oui</p>
                    </ng-container>
                    <ng-container *ngIf="!installation.sav.synchro_enabled">
                        <p class="col-6 col-sm-3">Non</p>
                    </ng-container>

                    <div class="w-100"></div>
                    <p class="col-6 col-sm-3">Attestation de caisse : </p>
                    <p class="col-6 col-sm-3">{{ installation.champs[this.champ[2]].valeur_champ }}</p>
                    <div class="w-100"></div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-header" id="implantationHeader">
                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                    data-target="#implantationCollapse" aria-expanded="false"
                    aria-controls="implantationCollapse">Implantation</button>
            </div>
            <div id="implantationCollapse" class="collapse" aria-labelledby="implantationHeader"
                data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a></div> -->
                    <p class="col-sm-3 col-6">Adresse : </p>
                    <p class="col-sm-3 col-6">{{ installation.adresse.adresse }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Complément : </p>
                    <p class="col-sm-3 col-6">{{ installation.adresse.complement_adresse }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Code postal : </p>
                    <p class="col-sm-3 col-6">{{ installation.adresse.code_postal }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Ville : </p>
                    <p class="col-sm-3 col-6">{{ installation.adresse.ville }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Pays : </p>
                    <p class="col-sm-3 col-6">{{ installation.adresse.pays }}</p>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Latitude : </p>
                    <p class="col-sm-3 col-6">{{ installation.adresse.latitude }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Longitude : </p>
                    <p class="col-sm-3 col-6">{{ installation.adresse.longitude }}</p>
                    <div class="w-100"></div>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Alimentation électrique : </p>
                    <p class="col-sm-3 col-6">{{ installation.alimentation_electrique.designation }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Type de kiosque : </p>
                    <p class="col-sm-3 col-6">{{ installation.type_kiosque }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Kiosque - Sens</p>
                    <p class="col-sm-3 col-6"> {{ installation.champs[this.champ[13]].valeur_champ }} </p>
                    <div class="w-100"></div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="contractHeader">
                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                    data-target="#contractCollapse" aria-expanded="false" aria-controls="contractCollapse">Contrat de
                    maintenance</button>
            </div>
            <div id="contractCollapse" class="collapse" aria-labelledby="contractHeader"
                data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a> <a href="">Supprimer ce
                            contrat</a>| <a href="">Nouveau contrat</a>
                        | <a href="">
                            << Précédent</a> <a href="">Voir le contrat actif</a> <a href="">Suivant >></a></div> -->
                    <p class="col-sm-3 col-6">Contrat : </p>
                    <p class="col-sm-3 col-6">Garantie</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Date de début : </p>
                    <p class="col-sm-3 col-6">24/04/2019</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Date d'expiration : </p>
                    <p class="col-sm-3 col-6">23/04/2021</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Commentaire : </p>
                    <p class="col-sm-3 col-6">2ème année hors déplacement</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Contrat SAV proposé : </p>
                    <p class="col-sm-3 col-6"> {{ installation.champs[this.champ[4]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Location : </p>
                    <div class="w-100">{{ installation.champs[this.champ[16]].valeur_champ }}</div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="machineHeader">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                    data-target="#machineCollapse" aria-expanded="false"
                    aria-controls="machineCollapse">Machine</button>
            </div>
            <div id="machineCollapse" class="collapse" aria-labelledby="machineHeader"
                data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a></div> -->
                    <p class="col-sm-3 col-6">Numéro de série : </p>
                    <p class="col-sm-3 col-6">{{ installation.machine.numero_serie }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Côté portes : </p>
                    <p class="col-sm-3 col-6">{{ installation.machine.cote_portes }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Date de destruction : </p>
                    <p class="col-sm-3 col-6">{{ installation.machine.date_destruction }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Alim. boutons (déf 24V) : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[1]].valeur_champ }}</p>
                    <div class="w-100"></div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="networkHeader">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                    data-target="#networkCollapse" aria-expanded="false" aria-controls="networkCollapse">Réseau</button>
            </div>
            <div id="networkCollapse" class="collapse" aria-labelledby="networkHeader"
                data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a></div> -->
                    <p class="w-100">Connexions : </p>
                    <p class="col-sm-3 col-6">- ADSL : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.connexions._ADSL.nom_value }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">- 3G : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.connexions._3G.nom_value }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">- RTC : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.connexions._RTC.nom_value }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Utiliser le tunneling : </p>

                    <ng-container *ngIf="installation.installation_network.tunneling_enabled">
                        <p class="col-sm-3 col-6">Oui</p>
                    </ng-container>
                    <ng-container *ngIf="!installation.installation_network.tunneling_enabled">
                        <p class="col-sm-3 col-6">Non</p>
                    </ng-container>


                    <div class="w-100"></div>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Téléphone</p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.telephone_rtc }}</p>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Modèle de modem/box : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.modem.nom_modem }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Identifiant modem/box : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.username_modem }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Mot de passe modem/box : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.password_modem }}</p>
                    <div class="w-100"></div>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Adresse IP : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.last_ip }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Dernière téléc. : </p>
                    <p class="col-sm-3 col-6">{{installation.installation_network.last_telecollecte}} </p>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Port VNC externe (Box) : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.port_vnc_externe }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Port VNC interne (PC) : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.port_vnc_interne }}</p>
                    <div class="w100"></div>
                    <p class="col-sm-3 col-6">Mot de passe VNC : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.password_vnc }}</p>
                    <div class="w100"></div>
                    <p class="col-sm-3 col-6">MdP VNC verrouilé : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.password_vnc_locked }}</p>
                    <div class="w100"></div>
                    <p class="col-sm-3 col-6">Port HTTP : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.port_http }}</p>
                    <div class="w100"></div>
                    <p class="col-sm-3 col-6">Identifiant LogMeIn : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.username_logmein }}</p>
                    <div class="w100"></div>
                    <p class="col-sm-3 col-6">Mot de passe LogMeIn : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.password_logmein }}</p>
                    <div class="w100"></div>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Identifiant SMS : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.username_sms }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Mot de passe SMS : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_network.password_sms }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Vidéosurveillance, MAC : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[25]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Vidéosurveillance, mdp : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[26]].valeur_champ }}</p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="terminalHeader">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                    data-target="#terminalCollapse" aria-expanded="false" aria-controls="terminalCollapse">TPA</button>
            </div>
            <div id="terminalCollapse" class="collapse" aria-labelledby="terminalHeader"
                data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a> <a href="">Nouveau contrat</a> -->
                    <!-- </div> -->
                    <p class="col-sm-3 col-6">Mise en service contrat : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_tpe.date_mise_en_service }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Numéro commerçant : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_tpe.numero_commercant }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Banque : </p>
                    <p class="col-sm-3 col-6"></p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Code banque : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_tpe.code_banque }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Numéro logique : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_tpe.numero_logique }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Numéro PAD : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_tpe.numero_pad }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Adresse d'appel : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_tpe.adresse_appel }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Passerelle IP : </p>
                    <p class="col-sm-3 col-6">Lyra - Network 2012</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Clé Xenteo : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_tpe.xenteo_key }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Commentaire : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_tpe.commentaire }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Sans-contact : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[17]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Téléphone SAV : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[23]].valeur_champ }}</p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="diverseHeader">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                    data-target="#diverseCollapse" aria-expanded="false" aria-controls="diverseCollapse">Divers</button>
            </div>
            <div id="diverseCollapse" class="collapse" aria-labelledby="diverseHeader"
                data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a></div> -->
                    <p class="col-sm-3 col-6">AlerteDeconnexion.Minutes : </p>
                    <p class="col-sm-3 col-6">&nbsp;</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Ski trappe froid : </p>
                    <p class="col-sm-3 col-6">&nbsp;</p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="advancementHeader">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                    data-target="#advancementCollapse" aria-expanded="false"
                    aria-controls="advancementCollapse">Avancement
                    du projet</button>
            </div>
            <div id="advancementCollapse" class="collapse" aria-labelledby="advancementHeader"
                data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a></div> -->
                    <p class="col-sm-3 col-6">Etat : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.projet_status.status_name }}</p>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Devis : </p>
                    <p class="col-sm-3 col-6">{{installation.installation_projet.devis}} </p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Commande signée : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.commande_signee.name }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Accompte : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.accompte.name }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Financement : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.financement.name }}</p>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Bail : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.bail.name }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Mairie : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.mairie.name }}</p>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Sens machine : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.sens.name }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Monnayeur / LdB : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.monnayeur.name }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Prise électrique envoyée : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.prise_electrique.name }}</p>
                    <div class="w-100">
                        <hr>
                    </div>
                    <p class="col-sm-3 col-6">Mode d'emploi : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.mode_emploi.name }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">HACCP : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.haccp.name }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Sérigraphie : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.serigraphie.name }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Remarque : </p>
                    <p class="col-sm-3 col-6">{{ installation.installation_projet.remarque }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Commercial : </p>
                    <p class="col-sm-3 col-6"></p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Garantie spéciale : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[9]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Installateurs : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[9]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Internet - Opérateur : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[11]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Internet - Type de connexion : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[12]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Période d'installation : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[16]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Vidéosurveillance</p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[25]].valeur_champ }}</p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="designHeader">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                    data-target="#designCollapse" aria-expanded="false" aria-controls="designCollapse">Visuel</button>
            </div>
            <div id="designCollapse" class="collapse" aria-labelledby="designHeader" data-parent="#propertiesAccordion">
                <div class="card-body row">
                    <!-- <div class="w-100"><a href="">Editer</a><a href="">Nouveau champ</a></div> -->
                    <p class="col-sm-3 col-6">Façade - Couleur : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[5]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Façade - Couleur bordure : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[6]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Façade - Couleur briques : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[7]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Façade - Couleur tôles : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[8]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Kiosque - type festons : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[9]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Sérigraphie - Couleur : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[19]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Sérigraphie - Police : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[20]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Sérigraphie - Texte Bas : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[21]].valeur_champ }}</p>
                    <div class="w-100"></div>
                    <p class="col-sm-3 col-6">Sérigraphie - Texte Haut : </p>
                    <p class="col-sm-3 col-6">{{ installation.champs[this.champ[22]].valeur_champ }}</p>
                </div>
            </div>
        </div>
    </ng-container>
</div>